// [FICHIER] Composant pour ajouter les attributs data-tutorial aux éléments existants
// [RÔLE] Injection des attributs data-tutorial via JavaScript pour l'App Guidance
// [ARCHITECTURE] Effet qui s'exécute au montage pour ajouter les attributs aux éléments DOM
// src/components/Tutorial/TutorialDataAttributes.tsx

import { useEffect } from 'react';

const TutorialDataAttributes = () => {
  useEffect(() => {
    // [DÉLAI] Attendre que la page soit complètement chargée
    const timer = setTimeout(() => {
      addTutorialAttributes();
    }, 1000);

    return () => clearTimeout(timer);
  }, []); // Exécuter une seule fois au montage

  const addTutorialAttributes = () => {
    try {
      // [INTERVIEW TAB] Onglet Interview
      const interviewLinks = document.querySelectorAll('a[href*="/process/interviews/"]');
      interviewLinks.forEach(link => {
        link.setAttribute('data-tutorial', 'interview-tab');
      });

      // [MAPPING TAB] Onglet Mapping/Cartographie
      const mappingLinks = document.querySelectorAll('a[href*="/process/mapping/"]');
      mappingLinks.forEach(link => {
        link.setAttribute('data-tutorial', 'mapping-tab');
      });

      // [ANALYSIS TAB] Onglet Analysis/Analyse
      const analysisLinks = document.querySelectorAll('a[href*="/process/analysis"]');
      analysisLinks.forEach(link => {
        link.setAttribute('data-tutorial', 'analysis-tab');
      });

      // [INTERVIEW ROLES] Liste des rôles dans les interviews
      const interviewList = document.querySelector('.customHeightInterview');
      if (interviewList) {
        interviewList.setAttribute('data-tutorial', 'interview-roles');
      }

      // [INTERVIEW SCENARIOS] Questions/réponses dans le chatbot
      const chatContainer = document.querySelector('.chat-container, .chatbot-container, .interview-chat, .chat-messages, .messages-container');
      if (chatContainer) {
        chatContainer.setAttribute('data-tutorial', 'interview-scenarios');
      }

      // [INTERVIEW INTELLIGENCE] Zone principale d'interview
      const interviewMainArea = document.querySelector('.interview-main, .chat-area, .conversation-area');
      if (interviewMainArea) {
        interviewMainArea.setAttribute('data-tutorial', 'interview-intelligence');
      }

      // [COLLABORATORS LIST] Liste des collaborateurs
      const collaboratorsList = document.querySelector('.interview-item, [class*="interview"]');
      if (collaboratorsList) {
        collaboratorsList.setAttribute('data-tutorial', 'interview-roles');
      }

      // [MAPPING BLOCKS] Blocs de la cartographie
      const mappingBlocks = document.querySelectorAll('.swimlane-block, .process-block, .mapping-element');
      mappingBlocks.forEach(block => {
        block.setAttribute('data-tutorial', 'mapping-blocks');
      });

      // [MAPPING FLOW] Flux visuel de la cartographie
      const mappingCanvas = document.querySelector('.swimlane-canvas, .mapping-canvas, .diagram-container');
      if (mappingCanvas) {
        mappingCanvas.setAttribute('data-tutorial', 'mapping-flow');
      }

      // [ANALYSIS BOTTLENECKS] Section des goulots d'étranglement
      const bottlenecksSection = document.querySelector('.bottlenecks, .analysis-bottlenecks, .insights-section');
      if (bottlenecksSection) {
        bottlenecksSection.setAttribute('data-tutorial', 'analysis-bottlenecks');
      }

      // [ANALYSIS OPTIMIZATION] Section des recommandations
      const optimizationSection = document.querySelector('.recommendations, .optimization, .suggestions-section');
      if (optimizationSection) {
        optimizationSection.setAttribute('data-tutorial', 'analysis-optimization');
      }

      // [GUIDANCE CTA] Bouton pour créer un nouveau processus
      const createProcessButtons = document.querySelectorAll('a[href*="/process/create"], button[data-create-process]');
      createProcessButtons.forEach(button => {
        button.setAttribute('data-tutorial', 'guidance-cta');
      });

      // [NAVIGATION SPÉCIFIQUE] Selon la page actuelle
      const currentPath = window.location.pathname;
      if (currentPath.includes('/process/interviews/')) {
        // Page Interview
        const interviewContainer = document.querySelector('.interview-container, main');
        if (interviewContainer) {
          interviewContainer.setAttribute('data-tutorial', 'interview-intelligence');
        }
      } else if (currentPath.includes('/process/mapping/')) {
        // Page Mapping
        const mappingContainer = document.querySelector('.mapping-container, main');
        if (mappingContainer) {
          mappingContainer.setAttribute('data-tutorial', 'mapping-magic');
        }
      } else if (currentPath.includes('/process/analysis')) {
        // Page Analysis
        const analysisContainer = document.querySelector('.analysis-container, main');
        if (analysisContainer) {
          analysisContainer.setAttribute('data-tutorial', 'analysis-insights');
        }
      }

      // [FALLBACK] Sélecteurs génériques si les spécifiques ne fonctionnent pas
      if (!document.querySelector('[data-tutorial="interview-tab"]')) {
        // Chercher des liens contenant "interview" dans le texte
        const allLinks = document.querySelectorAll('a');
        allLinks.forEach(link => {
          const text = link.textContent?.toLowerCase() || '';
          if (text.includes('interview') || text.includes('entretien')) {
            link.setAttribute('data-tutorial', 'interview-tab');
          }
        });
      }

      if (!document.querySelector('[data-tutorial="mapping-tab"]')) {
        // Chercher des liens contenant "mapping" ou "cartographie"
        const allLinks = document.querySelectorAll('a');
        allLinks.forEach(link => {
          const text = link.textContent?.toLowerCase() || '';
          if (text.includes('mapping') || text.includes('cartographie') || text.includes('diagramme')) {
            link.setAttribute('data-tutorial', 'mapping-tab');
          }
        });
      }

      if (!document.querySelector('[data-tutorial="analysis-tab"]')) {
        // Chercher des liens contenant "analysis" ou "analyse"
        const allLinks = document.querySelectorAll('a');
        allLinks.forEach(link => {
          const text = link.textContent?.toLowerCase() || '';
          if (text.includes('analysis') || text.includes('analyse')) {
            link.setAttribute('data-tutorial', 'analysis-tab');
          }
        });
      }

      console.log('🎯 [TUTORIAL DATA ATTRIBUTES] Added data-tutorial attributes to elements');
    } catch (error) {
      console.warn('⚠️ [TUTORIAL DATA ATTRIBUTES] Error adding attributes:', error);
    }
  };

  // Ce composant ne rend rien, il ne fait qu'ajouter des attributs
  return null;
};

export default TutorialDataAttributes;
